import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge class names, letting later Tailwind classes win over earlier ones.
 *
 * The shadcn/ui convention (D4). Without twMerge, passing `className="p-8"` to
 * a component whose base is `p-4` yields `p-4 p-8` and the winner depends on
 * stylesheet order rather than on the caller's intent.
 */
export function cn (...inputs) {
  return twMerge(clsx(inputs))
}

/**
 * A person's display name from the two-column shape the schema uses.
 * `last_name` is nullable by design (Phase 1 D3): contractor lead forms collect
 * one name field, and splitting on whitespace invents data. So a client may
 * legitimately have only a first name, and this must never render "Dana null"
 * or a trailing space.
 *
 * @param {{first_name?: string|null, last_name?: string|null}|null|undefined} person
 * @returns {string}
 */
export function fullName (person) {
  if (!person) return ''
  return [person.first_name, person.last_name].filter(Boolean).join(' ').trim()
}

/**
 * Initials for an avatar fallback. Same nullable-last-name rule.
 * @param {{first_name?: string|null, last_name?: string|null}|null} person
 */
export function initials (person) {
  const name = fullName(person)
  if (!name) return '?'
  const parts = name.split(/\s+/)
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase()
}
